import React from "react";
import { Container, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-page d-flex align-items-center justify-content-center py-5">
      <Helmet>
        <title>404 - Không Tìm Thấy Trang</title>
      </Helmet>

      <Container>
        <div className="text-center">
          <Card className="border-0 shadow-lg p-5 rounded-4 bg-white mx-auto" style={{ maxWidth: "560px" }}>
            <div className="error-badge mb-3">
              <span className="display-1 fw-extrabold text-primary">404</span>
            </div>
            <h4 className="fw-bold text-dark mb-2">Không Tìm Thấy Trang Phù Hợp</h4>
            <p className="text-secondary small mb-4">
              Rất tiếc, đường dẫn bạn đang truy cập không tồn tại hoặc đã bị di chuyển sang khu vực khác trên hệ thống SmartPark.
            </p>
            <div>
              <Button as={Link} to="/" variant="primary" size="lg" className="rounded-pill px-5 py-2.5 fw-bold shadow-sm">
                <i className="bi bi-house-door-fill me-2"></i> Quay về Trang chủ
              </Button>
            </div>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default NotFound;
